export const Resources = {
    SubscribeAriaLabel: 'Suscríbete aquí para recibir las últimas Noticias del Ministerio y/o a las Notas de Prensa',
    BellGreetingLogged: '¡Hola ',
    BellGreeting: '¡Hola!',
    BellText01: 'Puede que te interese suscribirte a las siguientes',
    BellText02: 'La suscripción se vinculará al siguiente mail',
    BellText03: 'Si desea modificarlo, puede hacerlo en la edición de datos de usuario',

    SubscribeTitle: 'Suscríbete',
    SubscribeTitleUperCase: 'SUSCRÍBETE',
    SubscribeBtnTitle: 'Suscríbete a las Newsletters del Ministerio',
    LoginSignUpUperCase: 'REGÍSTRATE',
    SubscriptionsManagerUperCase: 'GESTIÓN DE SUSCRIPCIONES',

    Cancel: 'Cancelar',
    Ok: 'Ok',

    SendActivationMailButton: 'Enviar email de activación',
    SendActivationMailOK: 'Email enviado correctamente al correo proporcionado.',
    SendActivationMailError: 'Error al enviar el mensaje. Por favor, inténtelo de nuevo más tarde.',
    
    LoginAuthentication: 'Identifícate',
    LoginRecoverPass: 'Recuperar contraseña',
    LoginSignUpText: 'Si todavía no tienes cuenta',
    LoginButton: 'Botón Identifícate',

    ToolTipCheckBell: 'Para eliminar la suscripción debe ir a Gestión de Suscripciones',
    EnterEmail: 'Introduzca su Email',
    EnterPass: 'Introduzca su Contraseña',

    RecoveryAccountModal: 'Se va a proceder al envio de un correo de recuperación de contraseña al email indicado',
    RecoveryAccountModalMailSended: 'Si el correo electrónico está registrado habrá recibido un email en su bandeja de entrada',

   
    //--------- Mensajes de Error -------------
    // SecurityPasswordChange: ServiceMessage1
    // InvalidCredentials: ServiceMessage3    
    // MailInUse: ServiceMessage4
    // DocInUso: ServiceMessage5
    // SendActivationEmailError: ServiceMessage6
    // SendRecoveryEmailError: ServiceMessage7
    // InvalidToken: ServiceMessage8
    // InternalServiceError: ServiceMessage9
    // GenerateJWTNoUser: ServiceMessage10
    // NoGroupId: ServiceMessage11
    // NoAuthenticated: ServiceMessage12
    // NoActiveUser: ServiceMessage13
    // NewActivationTokenError: ServiceMessage14
    // UserNoExist: ServiceMessage16

    ServiceMessage1: 'Hemos mejorado el sistema de seguridad para acceder a sus suscripciones, por ello es necesario cambiar la contraseña. Puede hacerlo desde el apartado de "Recuperar Contraseña".',
    ServiceMessage2: '',
    ServiceMessage3: 'No existe una cuenta asociada al email indicado o la contraseña es incorrecta.',
    ServiceMessage4: 'El correo electrónico proporcionado se encuentra en uso.',
    ServiceMessage5: 'Documento de identidad en uso.',
    ServiceMessage6: 'Usuario creado correctamente. Error al enviar el email de activación de usuario.',
    ServiceMessage7: 'Error al enviar el email de recuperación de usuario.',
    ServiceMessage8: 'El Identificador es incorrecto o ha expirado. En caso de ser un usuario nuevo deberá proceder a un nuevo registro.',
    ServiceMessage9: 'Error interno del servicio.',
    ServiceMessage10: 'No se puede recuperar el usuario.',
    ServiceMessage11: 'Se ha producido un error en la obtención de las publicaciones del usuario. Por favor, si el problema persiste, contacte con el servicio técnico.',
    ServiceMessage12: 'Ningún usuario con sesión activa.',
    ServiceMessage13: 'El usuario aún no ha activado la cuenta.',
    ServiceMessage14: 'Error al generar un nuevo código de activación.',
    ServiceMessage15: '',
    ServiceMessage16: 'No existe una cuenta asociada al email indicado.',
    ServiceMessage17: 'La contraseña actual no es correcta.',
    ServiceMessage19: "La nueva contraseña no puede ser igual que la contraseña actual.",
    ServiceMessage21: "Debe completar el captcha.",

    ServiceMessage503: 'El servicio de suscripciones no se encuentra disponible, por favor, inténtelo más tarde. Disculpe las molestias.',

    ErrorCode0: 'Ok',
    ErrorCode1: 'El correo electrónico no puede estar vacío',
    ErrorCode2: 'El correo electrónico es erróneo',
    ErrorCode3: 'La contraseña no puede estar vacía',
    ErrorCode4: 'Al menos debe seleccionarse una suscripción',
    ErrorCode5: 'Debe completar el captcha',
    ErrorCode6: 'La contraseña elegida no es suficientemente segura. Debe tener al menos 8 caracteres, mayúsculas, minúsculas, números y símbolos. Los símbolos admitidos son: _!@#$%^&*.-',
}